import { matchRoutes, useLocation } from "react-router-dom";

export const routes = {
  root: "/:locale",
  home: "/home/:locale",
  faq: "/faq/:locale",
  about: "/about-the-tests/:locale",
  disclaimer: "/disclaimer/:locale",
};

export const routesBase = {
  root: "/",
  home: "/home",
  faq: "/faq",
  about: "/about-the-tests",
  disclaimer: "/disclaimer",
};

const routerRoutes = Object.values(routes).map((path) => ({ path }));

export function usePathPattern() {
  const location = useLocation();
  const match = matchRoutes(routerRoutes, location);
  if (match) {
    return match[0]?.route?.path;
  }
  return routes.root;
}
